// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"4baf394b","275":"dfc3c2c4","502":"16751593","583":"f55e13c8","787":"a54cc342"}[chunkId] + ".chunk.js";
};